import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import '@/styles/components/table-item.scss'
import type { CSSProperties } from 'vue'
import '@/styles/components/table-item-cell.scss'

interface TableItemProps {
  totalAmount?: string
  currentValue?: string
  source?: 'buy' | 'sell'
  maxAmount?: string
  style?: CSSProperties
}

export const TableItem = defineComponent<TableItemProps>({
  props: DefineComponentProps<TableItemProps>(['totalAmount', 'currentValue', 'source', 'maxAmount', 'style']),
  setup(props, { slots }) {
    const scaleX = computed(() => {
      if (!props.totalAmount || !props.currentValue) {
        return 0
      }

      const w = props.currentValue.divideStr(props.totalAmount)
      return w
    })
    return () => (
      <div class={'table-body-item-container'}>
        <div class="table-body-item">{slots.default?.()}</div>
        <div
          class={classNames('area', {
            up: props.source === 'buy',
            down: props.source === 'sell',
          })}
          style={{ transform: `scaleX(${scaleX.value})` }}
        ></div>
      </div>
    )
  },
})

interface TableItemCellProps {
  style?: CSSProperties
  class?: string
}

export const TableItemCell = defineComponent<TableItemCellProps>({
  props: DefineComponentProps<TableItemCellProps>(['style', 'class']),
  setup(props, { slots }) {
    return () => (
      <div class={classNames('table-body-item-cell', props.class)} style={props.style}>
        {slots.default?.()}
      </div>
    )
  },
})
